<template>
	<div>

		<div class="small-margin-bottom">
			<h3 style="margin-top: 0px; margin-bottom: 8px;">Manage exchange</h3>
			Select the products you want to create exchange requests for.
			When you click on a product, you will see available sizes/variants and in the parentheses the stock status of the variant.
		</div>

		<div
			v-for="line in data.order_lines"
			class="border-bottom small-padding-bottom small-padding-top">
			<div
				class="clickable flex xs-margin-bottom"
				style="align-items: center; font-size: 15px; font-weight: 400">
				<div
					class="xs-margin-right"
					:style="'background-image: url(\'' + line.product.thumbnail + '\'); background-size: cover; background-position: center center; height: 30px; width: 30px; border-radius: 50%; border: 1px solid #aaa'"></div>
				<div
					v-on:click="toggle(line)">
					{{ line.variant.sku }}
					(Original: {{ String(line.variant.size).toUpperCase() }})
				</div>
				<div
					class="xs-margin-left"
					style="padding: 4px; padding-left:  8px; padding-right:  8px; font-weight:  300; font-size: 13px; border: 1px solid #666; border-radius: 3px;"
					v-if="blocked[line.product.id]">Processed</div>
				<div
					class="small-margin-left"
					v-else>
					<button
						class="small gray"
						v-on:click="createExchange(line)"
						v-if="data.exchange_requests[line.product.id]"
						:disabled="saving">Create exchange order</button>
				</div>
			</div>
			<div
				class="small-margin-top flex"
				v-if="line._expand">
				<div
					class="flex flex-vertical-center small-margin-right"
					v-for="ex_line in line.exchangeable">
					<input
						:id="'ex-variant-' + ex_line.id"
						:group="'ex-variant-' + line.product.id"
						:value="ex_line.id"
						:disabled="blocked[line.product.id]"
						type="radio"
						v-model="exchange_requests[line.product.id]" />
					<label
						:for="'ex-variant-' + ex_line.id">
						{{ String(ex_line.size).toUpperCase() }}
						({{ ex_line.stock.qty_available }})
					</label>
				</div>
			</div>
		</div>

		<div
			class="margin-top">
			<button
				:disabled="saving"
				v-on:click="create"
				class="small">Save</button>
		</div>

	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    id: {
      required: true
    },
    data: {
      required: true
    }
  },
  computed: {
    blocked () {
      var list = {}

      for (var e in this.data.exchange_requests) {
        const exchangeRequest = this.data.exchange_requests[e]
        if (exchangeRequest.assigned_order) {
          list[exchangeRequest.product.id] = true
        }
      }

      return list
    }
  },
  data: () => ({
    saving: false,
    exchange_requests: {}
  }),
  methods: {
    createExchange (line) {
      Vue.$api.post('/testing/order/' + this.id + '/line/' + line.product.id + '/exchange-order', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.$emit('updated')
      })
    },
    toggle (row) {
      Vue.set(row, '_expand', !row._expand)
    },
    create () {
      Vue.$api.put('/testing/order/' + this.id + '/exchange-requests', {
        exchange_requests: this.exchange_requests
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.$emit('updated')
      })
    },
    initialize () {
      for (var e in this.data.exchange_requests) {
        const exchangeRequest = this.data.exchange_requests[e]

        Vue.set(
          this.exchange_requests,
          exchangeRequest.product.id,
          exchangeRequest.variant.id
        )

        for (var orderLine of this.data.order_lines) {
          if (orderLine.product.id == exchangeRequest.product.id) {
            Vue.set(orderLine, '_expand', true)
          }
        }
      }
    }
  },
  created () {
    setTimeout(() => this.initialize(), 100)
  }
}
</script>
